"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortBestToWorst = void 0;
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const SortBestToWorst = ({ colour = "#e6e6e6", size = 16, title }) => {
    return (react_1.default.createElement(Base_1.Base, { size: size, title: title },
        react_1.default.createElement("path", { shapeRendering: "geometricPrecision", d: "m1 6h2v-5h2v5h2l-3 5z", fill: colour }),
        react_1.default.createElement("g", { fill: "#ff626d" },
            react_1.default.createElement("rect", { x: "8", y: "9", width: "7", height: "2" }),
            react_1.default.createElement("rect", { x: "4", y: "13", width: "11", height: "2" })),
        react_1.default.createElement("g", { fill: "#8ee43f" },
            react_1.default.createElement("rect", { x: "10", y: "1", width: "5", height: "2" }),
            react_1.default.createElement("rect", { x: "9", y: "5", width: "6", height: "2" }))));
};
exports.SortBestToWorst = SortBestToWorst;
//# sourceMappingURL=SortBestToWorst.js.map